////////LIBRARY/////////
import update from 'immutability-helper'
import { cloneDeep, findIndex } from 'lodash'
///////COMPONENTS///////
import extendUpdate from '../../helpers/extendUpdate'
import ActionsTypes from '../../constants/ActionsTypes'

extendUpdate(update)

const kioskEditImplantation = {
	[ActionsTypes.POST_KIOSK_EDIT_IMPLANTATION]: (state) =>
		update(state, {
			kioskEditImplantation: {
				isLoading: {
					$set: true,
				},
				error: {
					$set: false,
				},

				data: {
					headerContent: {
						contentPagined: {
							content: {
								$set: [],
							},
						},
					},
				},
				isUpdate: {
					$set: false,
				},
			},
			columns: {
				isSearchfieldUpdated: {
					$set: false,
				},
			},
		}),
	[ActionsTypes.POST_KIOSK_EDIT_IMPLANTATION_SUCCESS]: (state, payload) => {
		return update(state, {
			kioskEditImplantation: {
				isLoading: {
					$set: false,
				},
				data: {
					$set: payload.data.body,
				},
			},
		})
	},
	[ActionsTypes.POST_KIOSK_EDIT_IMPLANTATION_FAILURE]: (state, payload) =>
		update(state, {
			kioskEditImplantation: {
				isLoading: {
					$set: false,
				},
				error: {
					$set: payload.error,
				},
			},
		}),

	[ActionsTypes.GET_KIOSK_EDIT_IMPLANTATION_ITEMS_CATALOG_GROWTH]: (state) =>
		update(state, {
			kioskEditImplantation: {
				isLoading: {
					$set: true,
				},
				catalog: {
					$set: {},
				},
			},
		}),
	[ActionsTypes.GET_KIOSK_EDIT_IMPLANTATION_ITEMS_CATALOG_GROWTH_SUCCESS]: (state, payload) => {
		return update(state, {
			kioskEditImplantation: {
				isLoading: {
					$set: false,
				},
				catalog: {
					$set: payload.data,
				},
			},
		})
	},
	[ActionsTypes.GET_KIOSK_EDIT_IMPLANTATION_ITEMS_CATALOG_GROWTH_FAILURE]: (state, payload) =>
		update(state, {
			kioskEditImplantation: {
				isLoading: {
					$set: false,
				},
				error: {
					$set: payload.error,
				},
			},
		}),
	[ActionsTypes.POST_KIOSK_EDIT_IMPLANTATION_UNIT_ACTION_WITH_ID]: (state) =>
		update(state, {
			kioskEditImplantation: {
				isLoading: {
					$set: true,
				},
				isUpdate: {
					$set: false,
				},
			},
		}),
	[ActionsTypes.POST_KIOSK_EDIT_IMPLANTATION_UNIT_ACTION_WITH_ID_SUCCESS]: (state, payload) => {
		const dataCp = cloneDeep(payload.data)
		const stateCp = cloneDeep(state.kioskEditImplantation.data)

		dataCp.forEach((elem, key) => {
			const idx = findIndex(stateCp.headerContent.contentPagined.content, (e) => e.id === elem.id)
			if (idx > -1) {
				stateCp.headerContent.contentPagined.content[idx] = elem
			}
		})
		return update(state, {
			kioskEditImplantation: {
				isLoading: {
					$set: false,
				},
				data: {
					$set: stateCp,
				},
				isUpdate: {
					$set: true,
				},
			},
		})
	},
	[ActionsTypes.POST_KIOSK_EDIT_IMPLANTATION_UNIT_ACTION_WITH_ID_FAILURE]: (state, payload) =>
		update(state, {
			kioskEditImplantation: {
				isLoading: {
					$set: false,
				},
				error: {
					$set: payload.error,
				},
			},
		}),
	[ActionsTypes.PUT_KIOSK_EDIT_IMPLANTATION_VALIDATE_IMPLANTATION]: (state) =>
		update(state, {
			kioskEditImplantation: {
				isLoading: {
					$set: true,
				},
			},
		}),
	[ActionsTypes.PUT_KIOSK_EDIT_IMPLANTATION_VALIDATE_IMPLANTATION_SUCCESS]: (state, _payload) => {
		return update(state, {
			kioskEditImplantation: {
				isLoading: {
					$set: false,
				},
				/*data: {
					$set: payload,
				},*/
			},
		})
	},
	[ActionsTypes.PUT_KIOSK_EDIT_IMPLANTATION_VALIDATE_IMPLANTATION_FAILURE]: (state, payload) =>
		update(state, {
			kioskEditImplantation: {
				isLoading: {
					$set: false,
				},
				error: {
					$set: payload.error,
				},
			},
		}),
	[ActionsTypes.RESET_DATA_EDIT_IMPLANTATION]: (state, _payload) =>
		update(state, {
			kioskEditImplantation: {
				error: {
					$set: false,
				},
				availableOptions: {
					$set: {},
				},
				data: {
					$set: {
						headerContent: {
							contentPagined: {
								content: [],
							},
						},
					},
				},
			},
		}),
	[ActionsTypes.RESET_ERROR_EDIT_IMPLANTATION]: (state, _payload) =>
		update(state, {
			kioskEditImplantation: {
				error: {
					$set: false,
				},
			},
		}),
}

export default kioskEditImplantation
